import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-input-group',
  templateUrl: './input-group.component.html',
  styleUrls: ['./input-group.component.scss'],
  standalone: true,
})
export class InputGroupComponent {
  @HostBinding('class.input-group') readonly isInputGroup = true;
}
